import firebase from 'firebase/app';
import Vue from 'vue'
import VueRouter from 'vue-router'
import PublisherService from '@/service/PublisherService'
import store from '@/store'

const publisherService = new PublisherService()

Vue.use(VueRouter)

const routes = [{
        path: '/',
        redirect: '/admin/overview'
        // name: 'Home',
        // component: Home
    },
    // {
    //     path: '/about',
    //     name: 'About',
    //     // route level code-splitting
    //     // this generates a separate chunk (about.[hash].js) for this route
    //     // which is lazy-loaded when the route is visited.
    //     component: () =>
    //         import ( /* webpackChunkName: "about" */ '../views/About.vue')
    // },
    // {
    //     path: '/maps',
    //     name: 'MapsCatalog',
    //     component: () =>
    //         import ( /* webpackChunkName: "mapscatalog" */ '../views/catalog/MapsCatalog.vue')
    // },
    {
        path: '/publishers/:publisherId/maps/:mapDefinitionFilename',
        name: 'PublisherMap',
        component: () =>
            import ( /* webpackChunkName: "MapViewer" */ '../views/publisher/map/MapViewer.vue'),
        props: true
    },
    {
        path: '/publishers/:publisherId/bundles/:mapBundleId/maps/:mapId/objects/:objectId',
        redirect: '/admin/publishers/:publisherId/maps/:mapId/objects/:objectId'
    },
    {
        path: '/bundles/:bundleId/maps/:mapDefinitionFilename',
        name: 'BundleMap',
        component: () =>
            import ( /* webpackChunkName: "MapViewer" */ '../views/publisher/map/MapViewer.vue'),
        props: true
    },
    {
        path: '/bundles/:bundleId/json/:mapDefinitionFilename',
        name: 'JSONMap',
        component: () =>
            import ( /* webpackChunkName: "JSONViewer" */ '../views/publisher/map/JSONViewer.vue'),
        props: true
    },
    {
        path: '/webviewers/:publisherId/maps/:mapId',
        name: 'WebViewer',
        component: () =>
            import ( /* webpackChunkName: "WebViewer" */ '../views/publisher/map/WebViewer.vue'),
        props: true
    },
    {
        path: '/login',
        name: 'Login',
        component: () =>
            import ( /* webpackChunkName: "Auth" */ '../views/authentication/Login.vue')
    },
    // {
    //     path: '/requestSubmission',
    //     name: 'RequestSubmission',
    //     component: () =>
    //         import ( /* webpackChunkName: "RequestSubmission" */ '../views/public/RequestSubmission.vue'),
    //     props: true
    // },
    {
        path: '/whereToStay',
        name: 'WhereToStay',
        component: () =>
            import ( /* webpackChunkName: "WhereToStay" */ '../views/public/WhereToStay.vue'),
        props: true
    },
    {
        path: '/facebook_dataDeletion',
        name: 'FacebookDataDeletion',
        component: () =>
            import ( /* webpackChunkName: "FacebookDataDeletion" */ '../views/public/FacebookDataDeletion.vue'),
        props: true
    },
    {
        path: '/admin',
        name: 'Admin',
        component: () =>
            import ( /* webpackChunkName: "Admin" */ '../views/admin/Admin.vue'),
        props: true,
        meta: {
            requiresAuth: true
        },
        children: [{
            path: "overview",
            name: "Overview",
            component: () =>
                import ( /* webpackChunkName: "AdminOverview" */ '../views/admin/overview/AdminOverview.vue')
        }, {
            path: "maps",
            name: "Maps",
            component: () =>
                import ( /* webpackChunkName: "AdminMaps" */ '../views/admin/map/Maps.vue')
        }, {
            path: "map/:mapId",
            name: "Map",
            component: () =>
                import ( /* webpackChunkName: "AdminMap" */ '../views/admin/map/Map.vue'),
        }, {
            path: "/map/:mapId/objects/:objectId",
            name: "MapObject"
        }, {
            path: 'publishers/:publisherId/maps/:mapId/objects/:objectId',
            name: 'MapObject',
            component: () =>
                import ( /* webpackChunkName: "PublisherDetail" */ '../views/admin/map/Map.vue'),
            beforeEnter: (to, from, next) => {
                const publisherId = to.params.publisherId;
                if (publisherId) {
                    publisherService.loadPublisher(publisherId).then((publisher) => {
                        store.commit("setCurrentPublisher",  publisher);
                        next();
                    }).catch((error) => {
                        // Nothing to do
                        console.log(error);
                    });
                }
            }
        }, {
            path: "messagecenter",
            name: "MessageCenter",
            component: () =>
                import ( /* webpackChunkName: "AdminNotifications" */ '../views/admin/messagecenter/MessageCenter.vue')
        }, 
        {
            path: "statistics",
            name: "Statistics",
            component: () =>
                import ( /* webpackChunkName: "AdminStatistics" */ '../views/admin/statistics/AdminStatistics.vue')
        }, {
            path: "configuration",
            name: "Configuration",
            component: () =>
                import ( /* webpackChunkName: "AdminConfiguration" */ '../views/admin/configuration/AdminConfiguration.vue')
        }, {
            path: "toolbox",
            name: "Toolbox",
            component: () =>
                import ( /* webpackChunkName: "AdminToolbox" */ '../views/admin/toolbox/Toolbox.vue')
        },


            
        /** To verify - might be to deprecate */            
        {
            path: 'dashboard',
            name: 'Dashboard',
            component: () =>
                import ( /* webpackChunkName: "AdminDashboard" */ '../views/admin/content/dashboard/Dashboard.vue')
        }, {
            path: 'operations',
            name: "Operations",
            component: () =>
                import ( /* webpackChunkName: "AdminOperations" */ '../views/admin/content/operations/OperationList.vue')
        }, {
            path: 'publishers',
            name: "Publishers",
            component: () =>
                import ( /* webpackChunkName: "AdminPublishers" */ '../views/admin/content/publishers/PublisherList.vue')
        }, {
            path: 'publishers/:publisherId',
            name: 'Publisher',
            component: () =>
                import ( /* webpackChunkName: "PublisherDetail" */ '../views/admin/content/publishers/PublisherDetail.vue')
        }, {
            path: 'publishers/:publisherId/banners',
            name: 'PublisherBanners',
            component: () =>
                import ( /* webpackChunkName: "PublisherBanners" */ '../views/admin/content/publishers/PublisherBannerList.vue')
        }, {
            path: 'publishers/:publisherId/maps/:mapId',
            name: 'Map',
            component: () =>
                import ( /* webpackChunkName: "PublisherDetail" */ '../views/admin/content/publishers/PublisherMap.vue')
        }, {
            path: 'users',
            name: "Users",
            component: () =>
                import ( /* webpackChunkName: "AdminUsers" */ '../views/admin/content/users/UserList.vue')
        }, {
            path: 'system',
            name: 'System',
            component: () =>
                import ( /* webpackChunkName: "WhereToStay" */ '../views/admin/content/system/System.vue')
        },
    ]
    },

    // {
    //     path: '/admin/login',
    //     name: 'Admin Login',
    //     component: () =>
    //         import ( /* webpackChunkName: "Admin" */ '../views/admin/authentication/Login.vue'),
    //     props: false
    // },
    // {
    //     path: '/admin/mbp/generate',
    //     name: 'MapBuilderProjectGenerator',
    //     component: () =>
    //         import ( /* webpackChunkName: "MapBuilderProjectGenerator" */ '../views/admin/map/MapBuilderProjectGenerator.vue'),
    //     props: true
    // }
]

const router = new VueRouter({
    mode: 'history',
    base: process.env.BASE_URL,
    routes
})

router.beforeEach((to, from, next) => {
    const requiresAuth = to.matched.some(x => x.meta.requiresAuth)
    const currentUser = firebase.auth().currentUser

    if (requiresAuth && !currentUser) {
        next('/login')
    } else if (requiresAuth && currentUser) {
        next()
    } else {
        next()
    }
});

export default router